/**
 * Mobile-optimized form components
 * Ensures 16px font size to prevent iOS zoom
 */

export function MobileInput({ label, type = 'text', className = '', ...props }) {
  return (
    <div>
      {label && (
        <label className="block text-sm md:text-base font-semibold text-text-primary mb-2">
          {label}
        </label>
      )}
      <input
        type={type}
        {...props}
        className={`
          w-full px-4 py-3 md:py-3
          text-base md:text-base
          border-2 border-border rounded-xl
          focus:outline-none focus:border-primary
          touch-target
          ${className}
        `}
        // Prevent zoom on iOS - must be at least 16px
        style={{ fontSize: '16px' }}
      />
    </div>
  );
}

export function MobileTextarea({ label, rows = 4, className = '', ...props }) {
  return (
    <div>
      {label && (
        <label className="block text-sm md:text-base font-semibold text-text-primary mb-2">
          {label}
        </label>
      )}
      <textarea
        rows={rows}
        {...props}
        className={`
          w-full px-4 py-3
          text-base
          border-2 border-border rounded-xl
          focus:outline-none focus:border-primary
          resize-none
          touch-target
          ${className}
        `}
        // Prevent zoom on iOS - must be at least 16px
        style={{ fontSize: '16px' }}
      />
    </div>
  );
}

export function MobileButton({ 
  children, 
  variant = 'primary', 
  fullWidth = false, 
  className = '',
  ...props 
}) {
  const baseClasses = "font-bold py-3 px-6 rounded-xl transition-transform active:scale-[0.98] touch-target";
  const variants = {
    primary: "bg-gradient-to-r from-primary to-primary-light text-white",
    secondary: "bg-white border-2 border-border text-text-primary hover:border-primary hover:text-primary",
    danger: "bg-red-500 text-white hover:bg-red-600",
    accent: "bg-gradient-to-r from-accent to-accent-light text-white"
  };

  return (
    <button
      {...props}
      className={`
        ${baseClasses}
        ${variants[variant]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `}
    >
      {children}
    </button>
  );
}

export function MobileSelect({ label, className = '', children, ...props }) {
  return (
    <div>
      {label && (
        <label className="block text-sm md:text-base font-semibold text-text-primary mb-2">
          {label}
        </label>
      )}
      <select
        {...props}
        className={`
          w-full px-4 py-3
          text-base
          border-2 border-border rounded-xl
          focus:outline-none focus:border-primary
          touch-target
          ${className}
        `}
        // Prevent zoom on iOS - must be at least 16px
        style={{ fontSize: '16px' }}
      >
        {children}
      </select>
    </div>
  );
}

